import { bedrockMcpQueryAnalyticsOutputSchema } from "schemas/agentTools/replo/bedrockMcp";
import { defineBedrockEndpointContract } from "schemas/bedrockApi/contract";
import { z } from "zod";

const queryAnalyticsParamsSchema = z.object({
  projectId: z.uuid(),
});

const queryAnalyticsBodySchema = z.object({
  query: z
    .string()
    .min(1)
    .describe(
      "A read-only ClickHouse SQL query against the project's Replo analytics data.",
    ),
});

const queryAnalyticsEndpoint = defineBedrockEndpointContract({
  operationId: "analytics.query",
  method: "post",
  path: "/api/v1/projects/{projectId}/analytics/query",
  routePath: "/{projectId}/analytics/query",
  description: "Run a read-only analytics query for a project",
  request: {
    params: queryAnalyticsParamsSchema,
    body: queryAnalyticsBodySchema,
  },
  response: {
    type: "json",
    schema: z.object({ data: bedrockMcpQueryAnalyticsOutputSchema }),
  },
});

export const analyticsSiteDomainsResponseSchema = z.object({
  /** Every storefront domain in the project's workspace, root-domains first. */
  allDomains: z.array(z.string()),
  /** The domains the project itself publishes on — the default filter selection. */
  currentProjectDomains: z.array(z.string()),
});

const siteDomainsEndpoint = defineBedrockEndpointContract({
  operationId: "analytics.siteDomains",
  method: "get",
  path: "/api/v1/projects/{projectId}/analytics/site-domains",
  routePath: "/{projectId}/analytics/site-domains",
  description:
    "List the storefront domains for a project's workspace, split into the project's own domains and every domain in the workspace",
  request: {
    params: z.object({ projectId: z.uuid() }),
  },
  response: {
    type: "json",
    schema: z.object({ data: analyticsSiteDomainsResponseSchema }),
  },
});

export const analyticsEndpointContracts = {
  query: queryAnalyticsEndpoint,
  siteDomains: siteDomainsEndpoint,
} as const;
